import { ChangeDetectionStrategy, Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { GridHeaderComponent } from '../grid-header/grid-header.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionnairesListItemComponent } from '../questionnaires-list-item/questionnaires-list-item.component';
import { QuestionnairesGridStore } from 'src/app/features/questionnaires/store/questionnairesGrid-store';
import { ManipulationsToolbarComponent } from "../../../../../../../../shared/components/manipulations-toolbar/manipulations-toolbar.component";
import { TemplatesPageComponent } from "../../../../../templates-grid/templates-page/templates-page.component";
import { map } from 'rxjs';
import { NoResultComponent } from 'src/app/shared/components/no-result/no-result.component';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { PageTypeEnum } from 'src/app/shared/models/filter.model';
import { QuestionnaireStatusFlowComponent } from "../../../questionnaire-status-flow/questionnaire-status-flow.component";

@Component({
    selector: 'que-questionnaires-list',
    templateUrl: './questionnaires-list.component.html',
    styleUrls: ['./questionnaires-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, QuestionnairesListItemComponent, GridHeaderComponent, TranslateDirective, TranslatePipe, ManipulationsToolbarComponent, TemplatesPageComponent, NoResultComponent, QuestionnaireStatusFlowComponent]
})
export class QuestionnairesListComponent implements OnInit {
  #questionnairesStore = inject(QuestionnairesGridStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  questionnaires$ = toSignal(this.#questionnairesStore.questionnaires$);
  questionnairesExtra$ = toSignal(this.#questionnairesStore.questionnairesExtra$);
  loadingExtra$ = toSignal(this.#questionnairesStore.loadingExtra$);
  isResult$ = toSignal(this.#questionnairesStore.totals$.pipe(map(x => x != undefined && x > 0)));
  isEmpty$ = toSignal(this.#questionnairesStore.isEmpty$);
  loading$ = toSignal(this.#questionnairesStore.loading$);
  currentQuestionnaire$ = toSignal(this.#questionnairesStore.currentQuestionnaire$);
  listView$=toSignal(this.#manipulationsToolbarStore.isListView$);

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.#manipulationsToolbarStore.updatePageType(PageTypeEnum.QuestionnairesList);
  }

  @ViewChildren('itemElement') itemsElements?: QueryList<ElementRef>;
  @ViewChildren('queItem') queItems?: QueryList<ElementRef>;

  isFilterListOpen$ = toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  scrollPositions: boolean[] = [];

  @HostListener('document:mousewheel', ['$event'])
  onWindowScroll(event: any) {
    const scrollContainer = this.el.nativeElement.querySelector('.scroll');
    if (scrollContainer) {
      const scrollBottom = scrollContainer.scrollHeight - scrollContainer.clientHeight;
      if (scrollContainer.scrollTop >= scrollBottom - 1) {
        var is10InExtra = this.questionnairesExtra$()!.result.length == 10;
        if (this.questionnairesExtra$() && this.questionnairesExtra$()!.result.length > 0) {
          this.getQuestionnaireExtra();
        }
        if (this.questionnairesExtra$() && is10InExtra && !this.loadingExtra$())
          this.loadMore();
      }
    }
  }
  checkPositions() {
    const threshold = 800; // px from the bottom of the viewport
    // if (this.itemsElements) {
    //   this.itemsElements.forEach((item, index) => {
    //     const itemBottom = item.nativeElement.getBoundingClientRect().bottom;
    //     const viewportBottom = window.innerHeight;
    //     const isNearBottom = (viewportBottom - itemBottom) <= threshold;
    //     this.scrollPositions[index] = isNearBottom;
    //   });
    // }
    // if (this.queItems) {
    //   const items = this.queItems.toArray();
    //   for (let i = 0; i < items.length; i++) {

    //     const item = items[i].nativeElement;
    //     const positionFromBottom = window.innerHeight - item.getBoundingClientRect().bottom;

    //     if (positionFromBottom <= threshold) {
    //       // Here, you'd update some state to mark this item as near the bottom
    //       // This could be an array of booleans corresponding to your items
    //     } else {
    //       // Update the state to mark this item as not near the bottom
    //     }
    //   }
    // }
  }

  isNearBottom(index: number): boolean {
    return this.scrollPositions[index];
  }
  getQuestionnaireExtra() {
    this.#questionnairesStore.updateQuestionnaireWithExtra();
  }

  loadMore() {
    this.#questionnairesStore.loadQuestionnariesForExtra();
  }

}
